export const UPDATE = 'UPDATE_DASHBOARD_DATA';
